export const FETCH_MENU_CURATION_TASKS = {
  START: 'START_FETCH_MENU_CURATION_TASKS',
  COMPLETE: 'COMPLETE_FETCH_MENU_CURATION_TASKS',
  FAIL: 'FAIL_FETCH_MENU_CURATION_TASKS',
  CLEANUP: 'CLEANUP_FETCH_MENU_CURATION_TASKS',
}

export const ASSIGN_MENU_CURATION_TASK_USER = {
  START: 'START_ASSIGN_MENU_CURATION_TASK_USER',
  COMPLETE: 'COMPLETE_ASSIGN_MENU_CURATION_TASK_USER',
  FAIL: 'FAIL_ASSIGN_MENU_CURATION_TASK_USER',
}

export const DELETE_FAKE_MENU = {
  START: 'START_DELETE_FAKE_MENU',
  COMPLETE: 'COMPLETE_DELETE_FAKE_MENU',
  FAIL: 'FAIL_DELETE_FAKE_MENU',
}

export const UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS =
  'UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS'

export const UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS =
  'UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS'

export const ALLOCATE_AUTOMATICALLY = {
  START: 'START_ALLOCATE_AUTOMATICALLY',
  COMPLETE: 'COMPLETE_ALLOCATE_AUTOMATICALLY',
  FAIL: 'FAIL_ALLOCATE_AUTOMATICALLY',
}

export const REMOVE_FROM_ALLOCATION = {
  START: 'START_REMOVE_FROM_ALLOCATION',
  COMPLETE: 'COMPLETE_REMOVE_FROM_ALLOCATION',
  FAIL: 'FAIL_REMOVE_FROM_ALLOCATION',
}
